import { TermsResponseDto } from '@core/api/generated/accounts/v1';
import { createReducer, on } from '@ngrx/store';
import * as LegalActions from '../actions/legal.actions';

export const initialState: TermsResponseDto = {
    signedTerms: [],
    pendingTerms: [],
};

export const legalTermsReducer = createReducer(
    initialState,
    on(LegalActions.loadLegalTermsSuccess, (state, { terms }) => terms)
);
